import React, { useState, useEffect } from 'react'
import LandingWrapper from './LandingWrapper'
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs'
import { Helmet } from "react-helmet";
import { FaUserCircle } from 'react-icons/fa'
import Fade from 'react-reveal/Fade';
import { GetReferencement, GetActualite, GetClient } from './Admin/Main/services'
import './styles.css'

const PAGE_NAME = 'REFERENCE'

const numberOfNewsToShow = 3;
var currentIndex = 0;

function displayElements() {
    const newsElements = document.querySelectorAll('.landing-actualite_items');

    for (let i = 0; i < newsElements.length; i++) {
        if (i >= currentIndex && i < currentIndex + numberOfNewsToShow) {
            newsElements[i].style.display = 'block';
        } else {
            newsElements[i].style.display = 'none';
        }
    }
}

function handleClick() {
    const newsContainer = document.querySelector('.news-list');
    const newsElements = document.querySelectorAll('.landing-actualite_items');


    currentIndex = (currentIndex + numberOfNewsToShow) % newsElements.length;
    displayElements();

    newsContainer.style.animation = 'expand 0.7s ease-out';
}

export default function LandingReference() {

    const [partenariats] = useState([
        {
            id: 1,
            name: 'Entreprise 1',
            img: null,
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quod., ur adipisicing elit. Quisquam, quod, ur adipisicing elit. Quisquam, quod'
        },
        {
            id: 2,
            name: 'Entreprise 2',
            img: null,
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quod., ur adipisicing elit. Quisquam, quod, ur adipisicing elit. Quisquam, quod, ur adipisicing elit. Quisquam, quod'
        },
        {
            id: 3,
            name: 'Entreprise 3',
            img: null,
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quod., ur adipisicing elit. Quisquam, quod, ur adipisicing elit. Quisquam, quod, ur adipisicing elit. Quisquam, quod, ur adipisicing elit. Quisquam, quod'
        }
    ])

    const [referencement, setReferencement] = useState(null)
    const [actualite, setActualite] = useState(null)
    const [client, setClient] = useState(null)

    useEffect(() => {
        GetReferencement().then(source => setReferencement(source))
        GetActualite().then(source => setActualite(source))
        GetClient().then(source => setClient(source))
    }, [])

    useEffect(() => {
        const newsElements = document.querySelectorAll('.landing-actualite_items');


        newsElements.forEach((element, index) => {
            if (index < numberOfNewsToShow) {
                element.style.display = 'flex';
            } else {
                element.style.display = 'none';
            }
        });
    }, [actualite])

    return (
        <LandingWrapper>
            <Helmet>
                <title>
                    {
                        referencement ?
                            referencement.find((dt) => dt.pageCible === PAGE_NAME) ? referencement.find((dt) => dt.pageCible === PAGE_NAME).siteTitle : "DKBSign"
                            : "DKBSign"
                    }
                </title>
                <meta
                    name="description"
                    content={
                        referencement ?
                            referencement.find((dt) => dt.pageCible === PAGE_NAME) ? referencement.find((dt) => dt.pageCible === PAGE_NAME).meta_description : ""
                            : ""
                    }
                />

                <meta
                    name="keywords"
                    content={
                        referencement ?
                            referencement.find((dt) => dt.pageCible === PAGE_NAME) ? referencement.find((dt) => dt.pageCible === PAGE_NAME).meta_keywords : ""
                            : ""
                    }
                />

                <meta name="robots" content={
                    referencement ?
                        referencement.find((dt) => dt.pageCible === PAGE_NAME) ? referencement.find((dt) => dt.pageCible === PAGE_NAME).meta_robots : ""
                        : ""
                }
                />
                <meta name="category" content={
                    referencement ?
                        referencement.find((dt) => dt.pageCible === PAGE_NAME) ? referencement.find((dt) => dt.pageCible === PAGE_NAME).meta_category : ""
                        : ""
                }
                />

                <meta name="identifier-url" content={
                    referencement ?
                        referencement.find((dt) => dt.pageCible === PAGE_NAME) ? referencement.find((dt) => dt.pageCible === PAGE_NAME).meta_identifier_url : ""
                        : ""
                }
                />

                <meta name="reply-to" content={
                    referencement ?
                        referencement.find((dt) => dt.pageCible === PAGE_NAME) ? referencement.find((dt) => dt.pageCible === PAGE_NAME).meta_reply_to : ""
                        : ""
                }
                />
            </Helmet>
            <Header />
            <Actualite data={actualite} />
            <div className="we-trust-us">
                <Fade duration={3000} left>
                    <div className="we-trust-us__title">Ils nous font confiance</div>
                </Fade>
                {client ? client.length > 0 ? <WeTrustUs partenariats={client} /> : <></> : <></>}
            </div>
        </LandingWrapper>
    )
}

const Header = () => {
    return (
        <React.Fragment>
            <div className="landing-reference__body-content">
                <div className="flip-header-reference">
                    <Fade duration={4000} left>
                        <div className="landing-reference__body-content-left-title">
                            <h1>Les clients et les références</h1>
                            <p>de notre offre de signature</p>
                        </div>
                    </Fade>
                </div>
            </div>
        </React.Fragment>
    )
}

const Actualite = ({ data }) => {
    return (
        <div className="landing-actualite">
            <p className="landing-partenaire__title"></p>
            <div className="landing-actualite__content">
                <div className="news-list">
                    <Fade duration={3000} top>
                        {
                            data ? data.length > 0 ? data.map((dt, key) => <ActualiteItem key={key} titre={dt.title} content={dt.content} created_at={dt.created_at} img={dt.img} />) : <></> : <></>
                        }
                    </Fade>
                </div>
                <div style={{ marginLeft: '18px' }} className="we-trust-us_content-direction">
                    <BsArrowRight color='white' />
                </div>
            </div>

        </div>
    )
}

const ActualiteItem = ({ titre, content, created_at, img }) => {
    return (
        <div className="landing-actualite_items">
            <img src={`http://127.0.0.1:8000/storage/actualities/${img}`} className="landing-actualite_items-img" />

            <div className="landing-actualite_items-content">
                <div className="landing-actualite_items-content-description">{content}</div>
                <div className="landing-actualite_items-content-title">{titre}</div>

                {/* <div className="landing-actualite_items-content-profile">
                <FaUserCircle className="landing-actualite_items-content-profile-img" />
                <div className="landing-actualite_items-content-profile-content">
                    <div className="landing-actualite_items-content-profile-content-name">{titre}</div>
                    <div className="landing-actualite_items-content-profile-content-date">{created_at}</div>
                </div>
            </div> */}
            </div>
        </div>
    )
}

const WeTrustUs = ({ partenariats }) => {
    const [index, setIndex] = useState(0)
    const [current, setCurrent] = useState(partenariats[0])

    return (
        <React.Fragment>
            <Fade duration={3000} left>
                <div className="we-trust-us_content">
                    <div
                        onClick={() => {
                            if (index > 0) {
                                setIndex(index - 1)
                                setCurrent(partenariats[index - 1])
                            }
                        }}
                        className="we-trust-us_content-direction">
                        <BsArrowLeft color='white' />
                    </div>
                    <Partenaire items={current} />
                    <div
                        onClick={() => {
                            if (index < partenariats.length - 1) {
                                setIndex(index + 1)
                                setCurrent(partenariats[index + 1])
                            }
                        }}
                        className="we-trust-us_content-direction">
                        <BsArrowRight color='white' />
                    </div>
                </div>
            </Fade>
        </React.Fragment>
    )
}

const Partenaire = ({ items }) => {
    return (
        <React.Fragment>
            <div className="partenaire">
                <img src={`https://dkbsign.com/dkbsign_web_api/public/storage/clients/${items.img}`} className="partenaire-logo" />
                <div className="partenaire-description">{items.description}</div>
            </div>
        </React.Fragment>
    )
}